import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {LocationChangeAction} from '@web/actions/application'
import {NPAY_BIZ} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'
import {getUrlInfo} from '@web/helpers/path'

import {NavigationResult, ThunkApi} from '../interfaces'

type NavigateToNpayBizEasyBankRegister = {
    channel: string
    successUrlQuery?: Record<string, string>
}

/**
 * NpayBiz 간편결제 계좌 등록 페이지로 이동
 */
const navigateToNpayBizEasyBankRegister = createAsyncThunk<
    NavigationResult,
    NavigateToNpayBizEasyBankRegister,
    ThunkApi
>('navigateTo/npayBizEasyBankRegister', async (args) => {
    const {channel, successUrlQuery} = args

    const easyBankRegisterUrl = `${NPAY_BIZ}/simplepay/${channel}/account/register/select`

    const url = qs.stringifyUrl({
        url: easyBankRegisterUrl,
        query: {
            successUrl: getUrlInfo({url: window.location.href, addQuery: successUrlQuery}).url,
            failUrl: window.location.href,
        },
    })

    changeBrowserLocation({url, type: LocationChangeAction.PUSH})
})

export default navigateToNpayBizEasyBankRegister
